$(function () {
    // @ vars ----------------------------------------------------------------------------------------------------------
    const FRM_ONLINE_COURSE = document.querySelector('.online-course__form')

    if (FRM_ONLINE_COURSE === null) {
        return
    }

    const INPUT_POSTCODE_INSTANCE_NAV = document.querySelector('#instance-navigation-data #postal_code'),
        FIELDS_REQUIRED = [],
        FIELDS_VALID = [],
        JQ_SELECT2 = $('.js__select2'),
        JQ_INPUT_MASKS = $('.js__input-mask'),
        JQ_BTN_SUBMIT = $('.online-course__form button'),
        INPUT_POSTCODE_ONLINE_COURSE = FRM_ONLINE_COURSE.querySelector('#postcode_hidden'),
        INPUT_GA4 = document.getElementById('_gl-oc'),
        FIELDS_ONLINE_COURSE = Array.from(FRM_ONLINE_COURSE.elements),
        CSS = {
            FORMFIELD: '.compact__section .online-course__form input, .compact__section .online-course__form select',
            SELECT_COUNTY: '.compact__section .online-course__form #county_id',
        }

    let interacted_with_online_course_form = false

    // @ plugins -------------------------------------------------------------------------------------------------------
    JQ_INPUT_MASKS.inputmask({
        removeMaskOnSubmit: true,
        autoUnmask: true,
        clearMaskOnLostFocus: true,
        showMaskOnHover: false,
    })

    JQ_SELECT2.select2({
        width: '100%',
        dropdownParent: $('#online-course-form'),
    })

    // @ functions -----------------------------------------------------------------------------------------------------
    $.fn.replaceClass = function (search, replace) {
        return this.each(function () {
            var $element = $(this)
            if (typeof search === 'string') {
                $element.removeClass(search).addClass(replace)
            } else if (Array.isArray(search)) {
                for (theClass of search) {
                    $element.removeClass(theClass).addClass(replace)
                }
            }
        })
    }

    const removeArrayElement = (the_array, the_value) => {
        let index = the_array.indexOf(the_value)

        if (index !== -1) {
            the_array.splice(index, 1)
        }

        return the_array
    }

    const addArrayElement = (the_array, the_value) => {
        if (the_array.indexOf(the_value) === -1) {
            the_array.push(the_value)
        }

        return the_array
    }

    const arraysAreEqual = (arr1, arr2) => {
        if (arr1.length !== arr2.length) {
            return false
        }

        arr1.sort()
        arr2.sort()

        return arr1.every((value, index) => {
            return value === arr2[index]
        })
    }

    const sendData = (data) => {
        return $.ajax({
            url: CCM_REL + '/index.php/tools/packages/forms/ajax.php',
            data: data,
            type: 'GET',
            dataType: 'json',
        })
    }

    const setFieldStatus = (jq_field, status) => {
        switch (status) {
            case 'is-valid':
                jq_field.replaceClass(['is-error', 'is-warning'], 'is-valid')
                jq_field.parent().replaceClass(['compact__form-element--has-error', 'compact__form-element--has-warning'], 'compact__form-element--has-valid')
                jq_field.siblings('label').replaceClass(['has-error', 'has-warning'], 'has-valid')
                jq_field.siblings('.help-message').text('')
                jq_field.siblings('.error-message').replaceClass('error-message', 'help-message').text('')
                break

            case 'is-warning':
                jq_field.replaceClass(['is-valid', 'is-error'], 'is-warning')
                jq_field.siblings('label').replaceClass(['has-error', 'has-valid'], 'has-warning')
                break

            case 'is-error':
                jq_field.replaceClass(['is-valid', 'is-warning'], 'is-error')
                jq_field.parent().replaceClass(['compact__form-element--has-valid', 'compact__form-element--has-warning'], 'compact__form-element--has-error')
                jq_field.siblings('label').replaceClass(['has-valid', 'has-warning'], 'has-error')
                jq_field.siblings('.help-message').replaceClass('help-message', 'error-message').text(jq_field.data('error-message'))
                break
        }

        jq_field.addClass(status)
    }

    const checkEmailSpelling = (data, jq_elem) => {
        sendData(data).done((response) => {
            if (response.type.length > 0) {
                if (response.type === 'did-you-mean') {
                    let str_suggestion = jq_elem.attr('data-did-you-mean-message').replace('[suggestion]', response.domain_suggestion)
                    let str_confirm = jq_elem.attr('data-did-you-mean-confirm')
                    let html_warning = `${str_suggestion} <span id="email-did-you-mean" data-email="${response.user}@${response.domain_suggestion}">${str_confirm}</span>`
                    jq_elem.siblings('.help-message').html(html_warning)
                }

                if (response.type === 'is-this-correct') {
                    let str_suggestion = jq_elem.attr('data-is-this-correct-message')
                    let str_confirm = jq_elem.attr('data-is-this-correct-confirm')
                    let html_warning = `${str_suggestion} <span id="email-is-this-correct">${str_confirm}</span>`
                    jq_elem.siblings('.help-message').html(html_warning)
                }

                setFieldStatus(jq_elem, 'is-warning')

                let email_did_you_mean = document.getElementById('email-did-you-mean')
                let email_is_this_correct = document.getElementById('email-is-this-correct')

                // 1 email domain suggestion found - jan@homail.com
                if (email_did_you_mean !== null) {
                    email_did_you_mean.addEventListener('click', () => {
                        jq_elem.val(email_did_you_mean.getAttribute('data-email'))
                        setFieldStatus(jq_elem, 'is-valid')
                    })
                }

                // multiple email domain suggestions found - jan@hotmail.c
                if (email_is_this_correct !== null) {
                    email_is_this_correct.addEventListener('click', () => {
                        setFieldStatus(jq_elem, 'is-valid')
                    })
                }
            }
        })
    }

    const handleFieldIsValid = (field_name, jq_elem) => {
        addArrayElement(FIELDS_VALID, field_name)
        setFieldStatus(jq_elem, 'is-valid')

        // new code for email domain validation --- jan@hotmal.com
        if (field_name === 'email' && jq_elem.attr('data-validate-email') === '1') {
            let data = {
                action: 'check email spelling',
                email: jq_elem.val(),
            }
            checkEmailSpelling(data, jq_elem)
        }
    }

    const handleFieldIsError = (field_name, jq_elem) => {
        removeArrayElement(FIELDS_VALID, field_name)
        setFieldStatus(jq_elem, 'is-error')
    }

    const collectParamsForDataLayer = () => {
        let formdata = {
            event: 'online-course-datalayer-push',
        }

        for (let i in FIELDS_ONLINE_COURSE) {
            if (FIELDS_ONLINE_COURSE[i].name.length > 0) {
                if (FIELDS_ONLINE_COURSE[i].value.length) {
                    formdata[FIELDS_ONLINE_COURSE[i].name] = FIELDS_ONLINE_COURSE[i].value
                }
            }
        }

        return formdata
    }

    const formIsValid = () => {
        for (let i in FIELDS_ONLINE_COURSE) {
            if (FIELDS_ONLINE_COURSE[i].classList.contains('err')) {
                return false
            }
        }

        return true
    }

    const debounce = (func, delay) => {
        let timeoutIds = {}

        return (...args) => {
            clearTimeout(timeoutIds[args[0].id])
            timeoutIds[args[0].id] = setTimeout(() => {
                func.apply(this, args)
            }, delay)
        }
    }

    const handleFormFieldValidation = (jq_field) => {
        let field_value = jq_field.val(),
            field_name = jq_field.attr('name')

        if (jq_field.attr('type') === 'checkbox') {
            if (jq_field.prop('checked') === false) {
                field_value = null
            }
        }

        if (jq_field.hasClass('js__input-mask')) {
            field_value = jq_field.inputmask('unmaskedvalue')
        }

        sendData({
            action: 'validate',
            binding: jq_field.data('binding'),
            value: field_value,
        }).done(function (json) {
            json.is_valid ? handleFieldIsValid(field_name, jq_field) : handleFieldIsError(field_name, jq_field)
            handleFormStyles()
        })
    }

    const handleFormStyles = () => {
        if (arraysAreEqual(FIELDS_REQUIRED, FIELDS_VALID)) {
            JQ_BTN_SUBMIT.prop('disabled', false)
            FRM_ONLINE_COURSE.classList.add('online-course__form--is-valid')
        } else {
            JQ_BTN_SUBMIT.prop('disabled', true)
            FRM_ONLINE_COURSE.classList.remove('online-course__form--is-valid')
        }
    }

    const handleFormFieldStyles = (jq_field) => {
        let field_value = jq_field.val()

        jq_field.parent().removeClass('compact__form-element--has-focus')

        if (field_value.length > 0) {
            jq_field.parent().addClass('compact__form-element--is-filled')
        } else {
            jq_field.parent().removeClass('compact__form-element--is-filled')
        }
    }

    const handleSubmit = () => {
        INPUT_GA4.value = google_tag_linker('get')
        JQ_BTN_SUBMIT.prop('disabled', true)
        JQ_BTN_SUBMIT.html('<i class="icon-submit-arrow-right icon-sm"></i>Please wait&hellip;')
        JQ_INPUT_MASKS.each(function (i, child) {
            let $child = $(child)
            if (typeof $child.inputmask === 'function') {
                $child.inputmask('remove')
            }
        })

        if (interacted_with_online_course_form && formIsValid()) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push(collectParamsForDataLayer())
        }
    }

    // @ event listeners -----------------------------------------------------------------------------------------------
    $(document).on('submit', '.online-course__form', function (e) {
        handleSubmit()
    })

    $(document).on('focus', '.compact__section .online-course__form input', function (e) {
        $(this).parent().addClass('compact__form-element--has-focus')
        interacted_with_online_course_form = true
    })

    $(document).on('blur', CSS.FORMFIELD, (e) => {
        let $this = $(this)
        handleFormFieldStyles($this)
    })

    $(document).on('keydown', '.select2-selection--single', function (e) {
        if (e.key === 'Tab') {
            JQ_SELECT2.blur()
        }
    })

    // @ inits ---------------------------------------------------------------------------------------------------------
    $('.online-course__form input[type=text]').attr('autocomplete', 'nope')

    JQ_BTN_SUBMIT.prop('disabled', true)

    if (INPUT_POSTCODE_ONLINE_COURSE && INPUT_POSTCODE_INSTANCE_NAV) {
        if (INPUT_POSTCODE_ONLINE_COURSE.value.length === 0) {
            INPUT_POSTCODE_ONLINE_COURSE.value = INPUT_POSTCODE_INSTANCE_NAV.value
        }
    }

    FRM_ONLINE_COURSE.querySelectorAll('input, select').forEach((field) => {
        if (field.getAttribute('data-binding')) {
            FIELDS_REQUIRED.push(field.name)

            switch (field.type) {
                case 'checkbox':
                    field.addEventListener('click', (e) => {
                        handleFormFieldValidation($(e.target))
                    })
                    break

                case 'text':
                    let debouncedValidation = debounce(handleFormFieldValidation, 950)
                    field.addEventListener('input', (e) => {
                        debouncedValidation($(e.target))
                    })
                    field.addEventListener('blur', (e) => {
                        if (e.target.value.length === 0 || e.target.name === 'phone') {
                            handleFormFieldValidation($(e.target))
                        }
                    })
                    break

                default:
                    field.addEventListener('blur', (e) => {
                        handleFormFieldValidation($(e.target))
                    })
                    break
            }

            if (field.type !== 'checkbox' && field.value.length > 0) {
                field.focus({ preventScroll: true })
                field.blur()
            }
        }
    })

    // special case for county dropdown because of select2 plugin
    $(document)
        .on('input', '.js__select2', (e) => {
            handleFormFieldValidation($(e.target))
        })
        .on('change', '.js__select2', (e) => {
            handleFormFieldValidation($(e.target))
        })
        .on('blur', '.js__select2', (e) => {
            handleFormFieldValidation($(e.target))
        })
})
